var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"forgot-password-link c-btn c-btn--w-large c-btn--h-large c-btn--center c-btn--border",attrs:{"to":_vm.forgotPasswordRoute}},[_vm._v("\n  パスワードをお忘れの方はこちら\n")])}
var staticRenderFns = []

export { render, staticRenderFns }